<template>
  <div class="showreel" id="showreel">
    <div class="row h-100 m-0">
      <div class="col-12 d-flex justify-content-center align-items-center">
        <vue-typed-js v-if="state.languageActive" :loop="true" :backSpeed="50" :backDelay="10000" :cursorChar="'|'" :startDelay="500" :typeSpeed="100" :strings="[state.translation.showreel.top]">
          <h1 class="top"><span class="typing"></span><span class="typed-cursor"></span></h1>
        </vue-typed-js>
        <div class="showreel-button hover-opacity" @mouseover="play()" @mouseout="stop()"><span class="pointer drotate"></span><br><div class="text">Showreel</div></div>
        <video ref="video" class="m-0 p-0 pointer" muted loop src="../assets/showreel.mp4" @mouseover="play()" @mouseout="stop()"></video>
        <vue-typed-js v-if="state.languageActive" :loop="true" :backSpeed="50" :showCursor="true" :backDelay="10000" :cursorChar="'|'" :startDelay="3000" :typeSpeed="100"  :strings="[state.translation.showreel.bottom]">
          <h1 class="bottom"><span class="typing"></span><span class="typed-cursor"></span></h1>
        </vue-typed-js>
      </div>
      <div class="col-12">
        <div class="scroll-downs pointer" @click="scroll()">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
        <div class="arrow pointer" @click="scroll()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from 'jquery'

export default {
  name: 'Showreel',
  data() {
    return {
      showreel: false,
      state: this.$root.$data.state,
    }
  },
  mounted() {
    if (this.state.isMobile) this.play();
  },
  methods: {
    play() {
        this.$refs.video.play();
    },
    stop() {
      this.$refs.video.play();
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;;
    },
    scroll() {
      let pageHeight = window.innerHeight;
      $('html, body').animate({
          scrollTop: pageHeight
      }, 1000);
    }
  }
}
</script>
